import { render, staticRenderFns } from "./CourseFeeSummaryView.vue?vue&type=template&id=3afe722d&"
import script from "./CourseFeeSummaryView.vue?vue&type=script&lang=js&"
export * from "./CourseFeeSummaryView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports